import React, { useState, useEffect } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  FormGroup,
  Label,
  Input,
  ButtonToggle,
  Button,
  Form,
  FormFeedback,
} from "reactstrap";
import { useFormik } from "formik";
import * as Yup from "yup";
import toast from "react-hot-toast";
import GoodCategoryServices from "../../services/AustServices/Good Category/GoodCategoryServices";
import { useDispatch } from "react-redux";
import Select from "react-select";
import AuthenticationsServices from "../../services/AuthenticationService/AuthenticationsServices";
import { Spinner } from "reactstrap";
import ParticlesAuth from "../AuthenticationInner/ParticlesAuth";
import imageLogo from "../../assets/orderingSystem/login-bg.jpg";
import arrow from "../../assets/schedie/curveArrow.svg";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

const Register = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [passwordShow, setPasswordShow] = useState(false);
  const [confirmPasswordShow, setConfirmPasswordShow] = useState(false);
  const [loading, setLoading] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      organizationName: "",
      confirmPassword: "",
      panNumber: "",
      address1: "",
      address2: "",
      tel: "",
      email: "",
      password: "",
      contactNo: "",
    },
    validationSchema: Yup.object({
      organizationName: Yup.string().required("Organization name is required"),
      panNumber: Yup.string().required("PAN number is required"),
      address1: Yup.string().required("Address is required"),
      address2: Yup.string(),
      email: Yup.string().email("Invalid email").required("Email is required"),
      password: Yup.string()
        .min(6, "Password must be at least 6 characters")
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password"), null], "Passwords must match")
        .required("Confirm password is required"),
      tel: Yup.string().required("Telephone number is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true);
      try {
        const response = await AuthenticationsServices.orgRegister(values);
        toast.success("New organization registered successfully.");
        navigate("/login");
        resetForm();
      } catch (error) {
        console.error(error);
        toast.error(
          error?.response?.data?.message ||
            error.message ||
            "Registration failed"
        );
      } finally {
        setLoading(false);
      }
    },
  });
  console.log("🚀 ~ Register ~ validation:", validation);

  return (
    <React.Fragment>
      <ParticlesAuth>
        <div className="vh-100">
          <Row className="h-100 g-0">
            {/* Login Form - Large screens */}
            <Col
              lg={{ size: 5, order: 2 }}
              md={{ size: 5, order: 2 }}
              xs={{ size: 12, order: 1 }}
              sm={{ size: 12, order: 1 }}
              xl={{ size: 6, order: 2 }}
              className="h-100 d-none d-sm-none d-md-block d-lg-block"
              style={{ backgroundColor: "#0f403b" }}
            >
              <div className="py-5 d-flex flex-column justify-content-center align-items-center h-100">
                <CardBody>
                  <div className="text-center mb-4">
                    <h5 className="text-white">
                      Sign up to continue to Ordering System admin panel
                    </h5>
                  </div>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="mb-3">
                      <Input
                        name="organizationName"
                        className="form-control p-3"
                        placeholder="Enter organization name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.organizationName}
                        invalid={
                          validation.touched.organizationName &&
                          validation.errors.organizationName
                        }
                      />
                      {validation.touched.organizationName &&
                        validation.errors.organizationName && (
                          <FormFeedback>
                            {validation.errors.organizationName}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3">
                      <Input
                        name="email"
                        className="form-control p-3"
                        placeholder="Enter email address"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={
                          validation.touched.email && validation.errors.email
                        }
                      />
                      {validation.touched.email && validation.errors.email && (
                        <FormFeedback>{validation.errors.email}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Input
                        name="address1"
                        className="form-control p-3"
                        placeholder="Enter address"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.address1}
                        invalid={
                          validation.touched.address1 &&
                          validation.errors.address1
                        }
                      />
                      {validation.touched.address1 &&
                        validation.errors.address1 && (
                          <FormFeedback>
                            {validation.errors.address1}
                          </FormFeedback>
                        )}
                    </div>

                    <Row>
                      <Col>
                        <div className="mb-3">
                          <Input
                            name="panNumber"
                            className="form-control p-3"
                            placeholder="Enter PAN number"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.panNumber}
                            invalid={
                              validation.touched.panNumber &&
                              validation.errors.panNumber
                            }
                          />
                          {validation.touched.panNumber &&
                            validation.errors.panNumber && (
                              <FormFeedback>
                                {validation.errors.panNumber}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col>
                        <div className="mb-3">
                          <Input
                            name="tel"
                            className="form-control p-3"
                            placeholder="Enter telephone number"
                            type="tel"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tel}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="mb-3 position-relative">
                      <Input
                        name="password"
                        value={validation.values.password}
                        type={passwordShow ? "text" : "password"}
                        className="form-control pe-5 p-3"
                        placeholder="Enter password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                        }
                      />
                      <button
                        className="btn btn-link position-absolute end-0 top-0 pt-3 text-muted"
                        type="button"
                        onClick={() => setPasswordShow(!passwordShow)}
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                      {validation.touched.password &&
                        validation.errors.password && (
                          <FormFeedback>
                            {validation.errors.password}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3 position-relative">
                      <Input
                        name="confirmPassword"
                        value={validation.values.confirmPassword}
                        type={confirmPasswordShow ? "text" : "password"}
                        className="form-control pe-5 p-3"
                        placeholder="Confirm password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.confirmPassword &&
                          validation.errors.confirmPassword
                        }
                      />
                      <button
                        className="btn btn-link position-absolute end-0 top-0 pt-3 text-muted"
                        type="button"
                        onClick={() =>
                          setConfirmPasswordShow(!confirmPasswordShow)
                        }
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                      {validation.touched.confirmPassword &&
                        validation.errors.confirmPassword && (
                          <FormFeedback>
                            {validation.errors.confirmPassword}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3">
                      <Button
                        disabled={loading}
                        color="success"
                        className="w-100"
                        type="submit"
                      >
                        {loading && (
                          <Spinner size="sm" className="me-2">
                            Loading...
                          </Spinner>
                        )}
                        Register
                      </Button>
                    </div>
                    <Col xs={12} lg={12} className="d-lg-block d-none mb-2 ">
                      <div className="text-center text-white">
                        Already registered account?{" "}
                        <Link to="/login" className="text-warning">
                          Login
                        </Link>
                      </div>
                    </Col>
                  </Form>
                </CardBody>

                <footer className="mt-auto w-100">
                  <div className="container text-center">
                    <p className="mb-0 text-muted">
                      &copy; {new Date().getFullYear()} Danfe Solution
                    </p>
                  </div>
                </footer>
              </div>
            </Col>

            {/* Image Part with Overlay - Large screens */}
            <Col
              lg={6}
              md={6}
              xl={6}
              xs={12}
              sm={12}
              className="position-relative h-100 d-none d-md-flex"
            >
              <img
                src={imageLogo}
                alt="Background"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <div className="login-overlay d-flex flex-column justify-content-center align-items-start p-4">
                <h1 className="fw-bold display-5 mb-4 text-white d-flex align-items-center">
                  Ordering Management System
                  <img
                    src={arrow}
                    alt=""
                    className="ms-2"
                    style={{ height: "40px" }}
                  />
                </h1>
              </div>
            </Col>

            {/* Login Form - Small screens */}
            <Col
              lg={6}
              xs={12}
              sm={12}
              xl={6}
              className="h-100 d-block d-md-none"
            >
              <img
                src={imageLogo}
                alt="Background"
                style={{ width: "100%", height: "100%", objectFit: "cover" }}
              />
              <div
                className="py-5 d-flex flex-column justify-content-center align-items-center h-100 position-absolute top-0 start-0 w-100"
                style={{ background: "rgba(0, 0, 0, 0.5)" }}
              >
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <h3 className="fw-bold text-white">
                      Ordering Management System
                      <img src={arrow} alt="" className="w-25" />
                    </h3>
                  </div>

                  <Form
                    onSubmit={(e) => {
                      e.preventDefault();
                      validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="mb-3">
                      <Input
                        name="organizationName"
                        className="form-control p-3"
                        placeholder="Enter organization name"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.organizationName}
                        invalid={
                          validation.touched.organizationName &&
                          validation.errors.organizationName
                        }
                      />
                      {validation.touched.organizationName &&
                        validation.errors.organizationName && (
                          <FormFeedback>
                            {validation.errors.organizationName}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3">
                      <Input
                        name="email"
                        className="form-control p-3"
                        placeholder="Enter email address"
                        type="email"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email}
                        invalid={
                          validation.touched.email && validation.errors.email
                        }
                      />
                      {validation.touched.email && validation.errors.email && (
                        <FormFeedback>{validation.errors.email}</FormFeedback>
                      )}
                    </div>

                    <div className="mb-3">
                      <Input
                        name="address1"
                        className="form-control p-3"
                        placeholder="Enter address"
                        type="text"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.address1}
                        invalid={
                          validation.touched.address1 &&
                          validation.errors.address1
                        }
                      />
                      {validation.touched.address1 &&
                        validation.errors.address1 && (
                          <FormFeedback>
                            {validation.errors.address1}
                          </FormFeedback>
                        )}
                    </div>

                    <Row>
                      <Col>
                        <div className="mb-3">
                          <Input
                            name="panNumber"
                            className="form-control p-3"
                            placeholder="Enter PAN number"
                            type="text"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.panNumber}
                            invalid={
                              validation.touched.panNumber &&
                              validation.errors.panNumber
                            }
                          />
                          {validation.touched.panNumber &&
                            validation.errors.panNumber && (
                              <FormFeedback>
                                {validation.errors.panNumber}
                              </FormFeedback>
                            )}
                        </div>
                      </Col>
                      <Col>
                        <div className="mb-3">
                          <Input
                            name="tel"
                            className="form-control p-3"
                            placeholder="Enter telephone number"
                            type="tel"
                            onChange={validation.handleChange}
                            onBlur={validation.handleBlur}
                            value={validation.values.tel}
                          />
                        </div>
                      </Col>
                    </Row>

                    <div className="mb-3 position-relative">
                      <Input
                        name="password"
                        value={validation.values.password}
                        type={passwordShow ? "text" : "password"}
                        className="form-control pe-5 p-3"
                        placeholder="Enter password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.password &&
                          validation.errors.password
                        }
                      />
                      <button
                        className="btn btn-link position-absolute end-0 top-0 pt-3 text-muted"
                        type="button"
                        onClick={() => setPasswordShow(!passwordShow)}
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                      {validation.touched.password &&
                        validation.errors.password && (
                          <FormFeedback>
                            {validation.errors.password}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3 position-relative">
                      <Input
                        name="confirmPassword"
                        value={validation.values.confirmPassword}
                        type={confirmPasswordShow ? "text" : "password"}
                        className="form-control pe-5 p-3"
                        placeholder="Confirm password"
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        invalid={
                          validation.touched.confirmPassword &&
                          validation.errors.confirmPassword
                        }
                      />
                      <button
                        className="btn btn-link position-absolute end-0 top-0 pt-3 text-muted"
                        type="button"
                        onClick={() =>
                          setConfirmPasswordShow(!confirmPasswordShow)
                        }
                      >
                        <i className="ri-eye-fill align-middle"></i>
                      </button>
                      {validation.touched.confirmPassword &&
                        validation.errors.confirmPassword && (
                          <FormFeedback>
                            {validation.errors.confirmPassword}
                          </FormFeedback>
                        )}
                    </div>

                    <div className="mb-3">
                      <Button
                        disabled={loading}
                        color="success"
                        className="w-100"
                        type="submit"
                      >
                        {loading && (
                          <Spinner size="sm" className="me-2">
                            Loading...
                          </Spinner>
                        )}
                        Register
                      </Button>
                    </div>
                    <Col xs={12} lg={6} className="d-lg-none d-block">
                      <div className="text-center text-white">
                        Already registered account?{" "}
                        <Link to="/login" className="text-warning">
                          Login
                        </Link>
                      </div>
                    </Col>
                  </Form>
                </CardBody>

                <footer className="mt-auto w-100">
                  <div className="container text-center">
                    <p className="mb-0 text-muted">
                      &copy; {new Date().getFullYear()} Danfe Solution
                    </p>
                  </div>
                </footer>
              </div>
            </Col>
          </Row>
        </div>
      </ParticlesAuth>
    </React.Fragment>
  );
};

export default Register;
